import { InjectionToken } from '@angular/core';
import { Environment } from '../models/environment';

export const ENVIRONMENT = new InjectionToken<Environment>('ENVIRONMENT');
